var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceIndisponible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    height: "auto",
    viewBox: "0 0 588.104 536.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22093",
    "data-name": "Groupe 22093",
    transform: "translate(-473.495 -217.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4640",
    "data-name": "Trac\\xE9 4640",
    d: "M340.568,568.8c148.046,0,268.061-120.015,268.061-268.061S488.613,32.682,340.568,32.682,72.507,152.7,72.507,300.743,192.522,568.8,340.568,568.8Z",
    transform: "translate(429.199 184.727)",
    fill: "#ecf4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4641",
    "data-name": "Trac\\xE9 4641",
    d: "M584.942,448.764,374.673,77.7c-25.713-45.365-67.745-45.365-93.463,0L70.943,448.764c-25.713,45.411-4.675,82.457,46.708,82.457H538.234c19.063,0,33.947-5.1,44-14,16.545-14.64,18.865-39.894,2.706-68.457ZM344.561,464.7H311.3V431.441h33.258Zm0-99.775H311.3V165.369h33.258Z",
    transform: "translate(414.032 198.022)",
    fill: "#a02528",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4642",
    "data-name": "Trac\\xE9 4642",
    d: "M256.044,287.677l26.3,5.944L273.1,230.138l-34.224,3.343Z",
    transform: "translate(630.439 423.563)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4643",
    "data-name": "Trac\\xE9 4643",
    d: "M256.044,287.677l26.3,5.944L273.1,230.138l-34.224,3.343Z",
    transform: "translate(630.439 423.563)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4644",
    "data-name": "Trac\\xE9 4644",
    d: "M305.422,290.927l-3.193-26.683-32.867-11.167s10.113,22.317-20.034,25.211c-32.591,3.131-24.634,14.961-24.634,14.961Z",
    transform: "translate(612.242 451.309)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4645",
    "data-name": "Trac\\xE9 4645",
    d: "M318.97,268.712l-102.376,1.379",
    transform: "translate(603.482 470.221)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4649",
    "data-name": "Trac\\xE9 4649",
    d: "M305.422,290.927l-3.193-26.683-32.867-11.167s10.113,22.317-20.034,25.211c-32.591,3.131-24.634,14.961-24.634,14.961Z",
    transform: "translate(612.242 451.309)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4650",
    "data-name": "Trac\\xE9 4650",
    d: "M315.117,284.974l-22.407,7.561L268.652,228.6l34.924,1.215,11.541,55.158Z",
    transform: "translate(666.45 421.704)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4651",
    "data-name": "Trac\\xE9 4651",
    d: "M315.117,284.974l-22.407,7.561L268.652,228.6l34.924,1.215,11.541,55.158Z",
    transform: "translate(666.45 421.704)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4652",
    "data-name": "Trac\\xE9 4652",
    d: "M289.193,290.892l-10.78-26.829,26.062-13.182s1.8,22.9,32.538,23.921c33.23,1.1,31.668,13.405,31.668,13.405l-79.487,2.685Z",
    transform: "translate(678.257 448.653)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4653",
    "data-name": "Trac\\xE9 4653",
    d: "M280.414,270.35l99.983-4.967",
    transform: "translate(680.677 466.195)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4657",
    "data-name": "Trac\\xE9 4657",
    d: "M289.193,290.892l-10.78-26.829,26.062-13.182s1.8,22.9,32.538,23.921c33.23,1.1,31.668,13.405,31.668,13.405l-79.487,2.685Z",
    transform: "translate(678.257 448.653)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4658",
    "data-name": "Trac\\xE9 4658",
    d: "M263.387,117.138H275.7c1.487,0,1.074,2.808-1.321,3.14h4.048c.331,0,3.113,3.27-5.674,3.949s-9.78,0-9.78,0l.413-7.088Z",
    transform: "translate(659.582 286.882)",
    fill: "#efd1d8",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4659",
    "data-name": "Trac\\xE9 4659",
    d: "M279.581,103.74s-22.449,21.283-22.891,22.493,5.729,16.749,5.729,16.749a19.347,19.347,0,0,0,5.511-.882s.331,2.976,7.163,2.755a22.888,22.888,0,0,1,10.138,1.432s5.4-5.288-12.011-7.051a54.648,54.648,0,0,1,.442-8.264c.442-.442,13.222-10.69,13.222-10.69l-7.3-16.543Z",
    transform: "translate(651.953 270.676)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4660",
    "data-name": "Trac\\xE9 4660",
    d: "M258.111,111.665a38.385,38.385,0,0,0,14.455,12.084l-7.635-15.7",
    transform: "translate(656.458 278.845)",
    fill: "#e3c9cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4661",
    "data-name": "Trac\\xE9 4661",
    d: "M279.581,103.74s-22.449,21.283-22.891,22.493,5.729,16.749,5.729,16.749a19.347,19.347,0,0,0,5.511-.882s.331,2.976,7.163,2.755a22.888,22.888,0,0,1,10.138,1.432s5.4-5.288-12.011-7.051a54.648,54.648,0,0,1,.442-8.264c.442-.442,13.222-10.69,13.222-10.69l-7.3-16.543Z",
    transform: "translate(651.953 270.676)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4662",
    "data-name": "Trac\\xE9 4662",
    d: "M242.639,96.816A20.833,20.833,0,1,0,221.8,75.983a20.832,20.832,0,0,0,20.834,20.833Z",
    transform: "translate(609.785 211.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4663",
    "data-name": "Trac\\xE9 4663",
    d: "M252.872,89.6A20.833,20.833,0,1,0,232.04,68.769,20.833,20.833,0,0,0,252.872,89.6Z",
    transform: "translate(622.166 203.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4664",
    "data-name": "Trac\\xE9 4664",
    d: "M247.2,81.443a20.833,20.833,0,1,0-20.832-20.832A20.834,20.834,0,0,0,247.2,81.443Z",
    transform: "translate(615.301 193.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4665",
    "data-name": "Trac\\xE9 4665",
    d: "M314.481,415.331s50.553,1.927,62.21-8.374L301.1,156.537a108.31,108.31,0,0,0-10.933-28.084l-17.449-23.718L245.35,111.2l-9.662,52.9,78.793,251.23Z",
    transform: "translate(626.578 271.881)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4666",
    "data-name": "Trac\\xE9 4666",
    d: "M256.166,131.16l35.119,171.889-57.246-86.118,26.937-55.708",
    transform: "translate(624.584 303.842)",
    fill: "#31333a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4667",
    "data-name": "Trac\\xE9 4667",
    d: "M265.367,245.082c24.509,6.841,65.613,0,75.428-9.384",
    transform: "translate(662.477 430.289)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4668",
    "data-name": "Trac\\xE9 4668",
    d: "M314.481,415.331s50.553,1.927,62.21-8.374L301.1,156.537a108.31,108.31,0,0,0-10.933-28.084l-17.449-23.718L245.35,111.2l-9.662,52.9,78.793,251.23Z",
    transform: "translate(626.578 271.881)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4669",
    "data-name": "Trac\\xE9 4669",
    d: "M279.584,161.559S289.3,177.05,296.065,178.6L337.377,150.5a16.22,16.22,0,0,0,1.034-22.708L283.775,72.374c-6.717-7.19-15.147-7.718-21.645-.278l-3.465-.137c-7.137,8.173-20.149,27.131-12.025,34.049l53.708,35.355-20.766,20.2Z",
    transform: "translate(636.704 225.927)",
    fill: "#129faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4670",
    "data-name": "Trac\\xE9 4670",
    d: "M272.025,81.5l4.566,33.907-19.276-14.322,10.4-18.268",
    transform: "translate(647.616 243.779)",
    fill: "#157580"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_22091",
    "data-name": "Groupe 22091",
    transform: "translate(490.908 276.649)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4671",
    "data-name": "Trac\\xE9 4671",
    d: "M159.559,236.352,476.207,116.966M162.993,258.841,479.64,139.453M166.427,281.33,483.074,161.942M169.861,303.816,486.508,184.429M145.826,146.4,462.472,27.017M149.26,168.891,465.905,49.5M152.692,191.378,469.339,71.991M156.126,213.867,472.773,94.48",
    transform: "translate(-145.826 -27.017)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.514
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4672",
    "data-name": "Trac\\xE9 4672",
    d: "M279.584,161.559S289.3,177.05,296.065,178.6L337.377,150.5a16.22,16.22,0,0,0,1.034-22.708L283.775,72.374c-6.717-7.19-15.147-7.718-21.645-.278l-3.465-.137c-7.137,8.173-20.149,27.131-12.025,34.049l53.708,35.355-20.766,20.2Z",
    transform: "translate(636.704 225.927)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4673",
    "data-name": "Trac\\xE9 4673",
    d: "M271.872,106.966l-30.861-2.229-11.594,19.8a93.677,93.677,0,0,0-11,64.1l28.68,237c38.241,6.4,62.518-8.385,62.518-8.385L278.242,159.324",
    transform: "translate(603.759 271.882)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4675",
    "data-name": "Trac\\xE9 4675",
    d: "M222.365,242.093c14.075,17.206,78.959,5.866,84.839-2.738",
    transform: "translate(610.463 434.711)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4676",
    "data-name": "Trac\\xE9 4676",
    d: "M232.78,117.138s-12.424,16.939-12.321,37.039l30.611,244.568",
    transform: "translate(608.157 286.882)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4677",
    "data-name": "Trac\\xE9 4677",
    d: "M271.872,106.966l-30.861-2.229-11.594,19.8a93.675,93.675,0,0,0-11,64.1l28.68,237c38.241,6.4,62.518-8.385,62.518-8.385L278.242,159.324",
    transform: "translate(603.759 271.882)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4678",
    "data-name": "Trac\\xE9 4678",
    d: "M310.952,72.722a14.337,14.337,0,0,0-3.756-2.145c-4.043-1.575-40.241-13.151-89.234-2.495,0,0,5.318,65.078,13.467,91.465a151.29,151.29,0,0,0,68.143.99s13.162-29.184,17.2-54.537",
    transform: "translate(605.137 222.149)",
    fill: "#129faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4679",
    "data-name": "Trac\\xE9 4679",
    d: "M271.2,83.086c3.339-8.555-2.815-18.947-13.746-23.216s-22.5-.791-25.837,7.762,2.815,18.947,13.746,23.214S267.861,91.639,271.2,83.086Z",
    transform: "translate(620.556 215.407)",
    fill: "#157580",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4681",
    "data-name": "Trac\\xE9 4681",
    d: "M265.171,80.517c3.261-6.386-1.268-15.222-10.113-19.738S236.4,57.774,233.137,64.16s1.268,15.22,10.115,19.736,18.66,3,21.919-3.381Z",
    transform: "translate(622.214 215.563)",
    fill: "#efd1d8",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4682",
    "data-name": "Trac\\xE9 4682",
    d: "M266.54,85.839l-6.076,34.683-43.633-7.91,43.2-21.745",
    transform: "translate(576.454 249.024)",
    fill: "#157580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4683",
    "data-name": "Trac\\xE9 4683",
    d: "M310.952,72.722a14.337,14.337,0,0,0-3.756-2.145c-4.043-1.575-40.241-13.151-89.234-2.495,0,0,5.318,65.078,13.467,91.465a151.29,151.29,0,0,0,68.143.99s13.162-29.184,17.2-54.537",
    transform: "translate(605.137 222.149)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4684",
    "data-name": "Trac\\xE9 4684",
    d: "M268.03,140.484H236.082a3.161,3.161,0,0,1-3.222-3.949l9.722-48.217a5.117,5.117,0,0,1,4.815-3.951h31.948a3.162,3.162,0,0,1,3.221,3.951l-9.722,48.217A5.117,5.117,0,0,1,268.03,140.484Z",
    transform: "translate(623.036 247.239)",
    fill: "#cde5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4687",
    "data-name": "Trac\\xE9 4687",
    d: "M268.03,140.484H236.082a3.161,3.161,0,0,1-3.222-3.949l9.722-48.217a5.117,5.117,0,0,1,4.815-3.951h31.948a3.162,3.162,0,0,1,3.221,3.951l-9.722,48.217a5.117,5.117,0,0,1-4.815,3.949Z",
    transform: "translate(623.036 247.239)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4688",
    "data-name": "Trac\\xE9 4688",
    d: "M250.746,103.161c2.393-1.989,3.016-5.184,1.39-7.144s-4.883-1.938-7.276.049-3.016,5.186-1.39,7.144S248.353,105.147,250.746,103.161Z",
    transform: "translate(634.895 259.575)",
    fill: "#dcdddd",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4689",
    "data-name": "Trac\\xE9 4689",
    d: "M256.552,79.346l1.6-26.974H238.524l-4.989,26.451",
    transform: "translate(623.974 208.543)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4690",
    "data-name": "Trac\\xE9 4690",
    d: "M252.5,76.388C235.782,57.6,248.74,64.117,238.013,56.731c-8.732-6.012,16.044,3.337,16.044,3.337L252.5,76.388Z",
    transform: "translate(627.512 211.098)",
    fill: "#e3c9cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4691",
    "data-name": "Trac\\xE9 4691",
    d: "M256.843,78.068l1.3-25.7H238.512s-3.837,18.205-5.084,24.818",
    transform: "translate(623.986 208.543)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4692",
    "data-name": "Trac\\xE9 4692",
    d: "M251.459,70a18.251,18.251,0,1,0-18.251-18.251A18.251,18.251,0,0,0,251.459,70Z",
    transform: "translate(623.578 185.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4693",
    "data-name": "Trac\\xE9 4693",
    d: "M245.8,77.734C270.461,91.4,271.712,54.7,260.832,46.1c-19.431-15.357-28.077,3.007-28.077,3.007l1,19.453",
    transform: "translate(623.03 193.555)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4694",
    "data-name": "Trac\\xE9 4694",
    d: "M245.8,77.734C270.461,91.4,271.712,54.7,260.832,46.1c-19.431-15.357-28.077,3.007-28.077,3.007l1,19.453",
    transform: "translate(623.03 193.555)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4695",
    "data-name": "Trac\\xE9 4695",
    d: "M232.525,69.938c11.43-3.009,12.042-16.044,12.042-16.044s8.681,1.016,10.946-4.229c0,0,7.316,9.243,13.823,2.424s-17.3-14.238-17.3-14.238l-15.7,5.816-5.215,7.621,1.2,16.645",
    transform: "translate(621.055 190.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4696",
    "data-name": "Trac\\xE9 4696",
    d: "M242.033,51.619c-11.077-10.434-17.361,10.237-.608,11.335Z",
    transform: "translate(621.073 204.084)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4697",
    "data-name": "Trac\\xE9 4697",
    d: "M242.033,51.619c-11.077-10.434-17.361,10.237-.608,11.335",
    transform: "translate(621.073 204.084)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4698",
    "data-name": "Trac\\xE9 4698",
    d: "M226.035,108.249a58.015,58.015,0,0,1,8.62-3.949c6.262-2.214,6.262-8.03,11.985-9,0,0-3.217,11.4,2.8,9.841,8.916-2.307,19.74-8.882,21.15-7.19s1.27,4.088-3.949,7.049c0,0,3.385,1.975.283,5.5,0,0,4.653,4.371-4.653,7.756s-32.852,8.989-32.852,8.989Z",
    transform: "translate(614.902 260.473)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4699",
    "data-name": "Trac\\xE9 4699",
    d: "M228.775,100.769s6.526,14.307,6.526,16.986-6.654.237-6.654.237l-.576-9.064",
    transform: "translate(617.366 267.082)",
    fill: "#e3c9cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4700",
    "data-name": "Trac\\xE9 4700",
    d: "M226.035,108.249a58.015,58.015,0,0,1,8.62-3.949c6.262-2.214,6.262-8.03,11.985-9,0,0-3.217,11.4,2.8,9.841,8.916-2.307,19.74-8.882,21.15-7.19s1.27,4.088-3.949,7.049c0,0,3.385,1.975.283,5.5,0,0,4.653,4.371-4.653,7.756s-32.852,8.989-32.852,8.989Z",
    transform: "translate(614.902 260.473)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4701",
    "data-name": "Trac\\xE9 4701",
    d: "M246.265,65.64a17.84,17.84,0,0,0-12.159,10.818l-37.132,81.056h0c-2.6,5.316-3.279,11.748-1.158,15.946,3.71,7.347,13.9,11.037,23.141,8.383l53.1-15.253c2.921-7.095-2.932-25.147-2.932-25.147l-17.345,2.026,21.444-38.994",
    transform: "translate(576.834 224.591)",
    fill: "#129faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4703",
    "data-name": "Trac\\xE9 4703",
    d: "M246.265,65.64a17.84,17.84,0,0,0-12.159,10.818l-37.132,81.056h0c-2.6,5.316-3.279,11.748-1.158,15.946,3.71,7.347,13.9,11.037,23.141,8.383l53.1-15.253c2.921-7.095-2.932-25.147-2.932-25.147l-17.345,2.026,21.444-38.994",
    transform: "translate(576.834 224.591)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4704",
    "data-name": "Trac\\xE9 4704",
    d: "M244.951,46.028c0,.243,2.152,5.131,2.152,5.131,5.455.391.274,3.918.274,3.918",
    transform: "translate(637.782 200.869)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4705",
    "data-name": "Trac\\xE9 4705",
    d: "M244.951,46.028c0,.243,2.152,5.131,2.152,5.131,5.455.391.274,3.918.274,3.918",
    transform: "translate(637.782 200.869)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4706",
    "data-name": "Trac\\xE9 4706",
    d: "M248.3,49.452a1.392,1.392,0,0,0,.961-1.673l-.325-1.229a1.294,1.294,0,0,0-1.64-.9,1.394,1.394,0,0,0-.961,1.673l.325,1.229a1.271,1.271,0,0,0,.628.8,1.3,1.3,0,0,0,1.012.1Z",
    transform: "translate(639.413 200.342)",
    fill: "#31333a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4707",
    "data-name": "Trac\\xE9 4707",
    d: "M251.774,44.1l-6.293,1.635",
    transform: "translate(638.424 198.54)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4708",
    "data-name": "Trac\\xE9 4708",
    d: "M244.488,50.306a1.394,1.394,0,0,0,.961-1.673l-.325-1.229a1.306,1.306,0,0,0-.628-.8,1.291,1.291,0,0,0-1.012-.1,1.392,1.392,0,0,0-.961,1.673l.325,1.229a1.272,1.272,0,0,0,.627.8A1.3,1.3,0,0,0,244.488,50.306Z",
    transform: "translate(634.796 201.375)",
    fill: "#31333a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4709",
    "data-name": "Trac\\xE9 4709",
    d: "M247.007,45.032l-6.291,1.635",
    transform: "translate(632.66 199.665)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4710",
    "data-name": "Trac\\xE9 4710",
    d: "M251.261,52.1l-9.024-1.668C238.7,59.5,251.626,60.274,251.261,52.1Z",
    transform: "translate(633.759 206.197)",
    fill: "#31333a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4711",
    "data-name": "Trac\\xE9 4711",
    d: "M258.861,52.528l-3.2-2.685m1.463,3.94-.044-2.585m11.545,114.449L280.391,160m.283,5.5-5.27,2.17m53.047,34.147,4.357-.137m-7.431,2.9,5.807,1.045M214.667,164.179l12.8-1.6m116.628-8.394-8.191,7.627",
    transform: "translate(601.152 205.483)",
    fill: "none",
    stroke: "#31333a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4712",
    "data-name": "Trac\\xE9 4712",
    d: "M79.523,152.877a11.9,11.9,0,1,0-11.9-11.9,11.9,11.9,0,0,0,11.9,11.9Zm495.439,70.662,20.085-7.32m-30.125,24.926L585,233.825",
    transform: "translate(423.288 301.317)",
    fill: "none",
    stroke: "#385b89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIndisponible);
export default __webpack_public_path__ + "static/media/serviceIndisponible.9e0a0994f378e945e6bf2b31fb8957c4.svg";
export { ForwardRef as ReactComponent };